export type TApiError = Error & {
  errorCode: TApiErrorCodes
}

export type TApiErrorCodes = keyof typeof RENDER_PROJECT_ERROR_CODE

export enum RENDER_PROJECT_ERROR_CODE {
  MAX_DURATION_EXCEEDED = 'MAX_DURATION_EXCEEDED',
  DURATION_EXCEEDED = 'DURATION_EXCEEDED',
  MAX_QUALITY_EXCEEDED = 'MAX_QUALITY_EXCEEDED',
  MIN_DURATION_EXCEEDED = 'MIN_DURATION_EXCEEDED'
}

export const upgradePopupErrorCodes = [
  RENDER_PROJECT_ERROR_CODE.DURATION_EXCEEDED,
  RENDER_PROJECT_ERROR_CODE.MAX_QUALITY_EXCEEDED
]
